import React from "react";

interface TurnstileWidgetProps {
    siteKey: string;
    widgetId: string;
}
const TurnstileWidget: React.FC<TurnstileWidgetProps> = ({ siteKey, widgetId }) => {
    return (
        <div className="turnstile-widget">
            <input type="hidden" name="turnstileSiteKey" className="turnstile-sitekey" data-sitekey={siteKey} value=""/>
            <div className="cf-turnstile" ></div>
            <input type="hidden" className="turnstile-token" name="cf-turnstile-response" value="" />

            <div className="turnstile-error" style={{ display: "none", color: "red" }}>
                CAPTCHA expired. Please try again.
            </div>
        </div>
    );
};

export default TurnstileWidget;